<template>
    <div>
        <div v-if="!withOTC">
            <div v-if="!withPrefix">
                <input :class="aspect.formFieldClass" type='text' :placeholder="placeholder" :value="value" :disabled="disabled" @input="e => set(e.target.value)">
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-2">
                        <select :class="aspect.formFieldClass" v-model="phonePrefix" @change="emitValue">
                            <option value="0039">+39</option>
                            <option v-for="prefix in prefixes" :key="prefix.key" :value="'00'+prefix">+{{prefix}}</option>
                        </select>
                    </div>
                    <div class="col-10">
                        <input :class="aspect.formFieldClass" type='text' :placeholder="placeholder" v-model="phoneValue" :disabled="disabled" @input="emitValue">
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div :class="aspect.rowClass" >
                <div :class="aspect.fieldColumnTwoQuarters">
                    <input :class="aspect.formFieldClass" type='text' :placeholder="placeholder" :value="value" @input="e => set(e.target.value)">
                </div>
                <div :class="aspect.fieldColumnAQuarter">
                    <button type="btn btn-primary" style="width: 100%;" :disabled="(!isValidPhone) || codeSent" @click="sendCode">{{translations.sendCode}}</button>
                </div>
            </div>
            <div :class="aspect.rowClass" style="margin-top:5px;" v-if='!validationRequired && codeSent && (!verificationCodeValidated)'>
                <div :class="aspect.fieldColumnTwoQuarters">
                    <input type="text" :class="aspect.formFieldClass" v-model="validationCode" :placeholder="translations.insertCodePlaceholder">
                </div>
                <div :class="aspect.fieldColumnAQuarter">
                    <button type="btn btn-primary" @click="sendVerification" style="width: 100%;">{{translations.validateCode}}</button>
                </div>
            </div>
            <div :class="aspect.rowClass">
                <div :class="aspect.rightColumnWrapperFullWidthClass">
                    <span v-if='!verificationCodeValidated && verificationCodeButtonClicked'>{{translations.pleaseInsertRightCodeWarning}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "form-element-phone",
        props: {
            value:{type:String},
            validations: {type: Array, default: function(){ return []; }},
            placeholder: null,
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }},
            disabled: {type: Boolean },
            withPrefix: {type: Boolean },
        },
        data() {
            return {
                urlCode: null,
                validateSessionURL: null,
                sessionID: null,
                validationCode: null,
                codeSent: false,
                validationRequired: false,
                phoneParam: null,
                codeParam: null,
                sessionParam: null,
                verificationCodeButtonClicked: false,
                verificationCodeValidated: false,
                phonePrefix: this.getPrefix(this.value),
                phoneValue: this.getPhoneNumber(this.value),
                prefixes: this.getPrefixes(),
            }
        },
        watch: {
            value(){
                this.codeSent = false
                this.verificationCodeValidated = false
                this.verificationCodeButtonClicked = false
            }
        },
        computed: {
            withOTC(){
                if(this.validations && this.validations.length > 0){
                    for(var i=0; i<this.validations.length; i++){
                        var validationCondition = this.validations[i];
                        if(validationCondition.type == "otc"){
                            this.urlCode = validationCondition.url
                            this.validateSessionURL = validationCondition.verificationUrl
                            this.phoneParam = validationCondition.phoneParam
                            this.codeParam = validationCondition.codeParam
                            this.sessionParam = validationCondition.sessionParam
                            return true
                        }
                    }
                }
                return false
            },
            v(){
                return this.value
            },
            isValidPhone(){
                return /^[\s()+-]*([0-9][\s()+-]*){6,20}$/.test(this.value)
            }
        },
        methods: {
            emitValue() {
                return this.$emit('input',this.phonePrefix+'-'+this.phoneValue);
            },
            getPrefix(number) {
                if(/(\+|[0]{2})([\d]{1,4})[-]([\d]{6,20})/g.test(number)) {
                    return number.match(/(\+|[0]{2})([\d]{1,4})/g)[0].replace('+','00');
                }else {
                    return '0039';
                }
            },
            getPhoneNumber(number) {
                return number.replace(this.getPrefix(number)+'-','');
            },
            getPrefixes() {
                return [376,971,93,1268,1264,355,374,599,244,672,54,1684,43,61,297,994,387,1246,880,32,226,359,973,257,229,590,1441,673,591,55,1242,975,267,375,501,1,61,243,236,242,41,225,682,56,237,86,57,506,53,238,61,357,420,49,253,45,1767,1809,213,593,372,20,291,34,251,358,679,500,691,298,33,241,44,1473,995,233,350,299,220,224,240,30,502,1671,245,592,852,504,385,509,36,62,353,972,44,91,964,98,354,1876,962,81,254,996,855,686,269,1869,850,82,965,1345,7,856,961,1758,423,94,231,266,370,352,371,218,212,377,373,382,1599,261,692,389,223,95,976,853,1670,222,1664,356,230,960,265,52,60,258,264,687,227,234,505,31,47,977,674,683,64,968,507,51,689,675,63,92,48,508,870,1,351,680,595,974,40,381,7,250,966,677,248,249,46,65,290,386,421,232,378,221,252,597,239,503,963,268,1649,235,228,66,992,690,670,993,216,676,90,1868,688,886,255,380,256,1,598,998,39,1784,58,1284,1340,84,678,681,685,381,967,262,27,260,263];
            },
            set(v){
                this.$emit('input', v);
            },
            sendCode(e){
                e.preventDefault()
                this.codeSent = true
                this.validationCode = null

                var glue = this.urlCode.includes("?")?"&":"?"
                axios.post(this.urlCode+glue+this.phoneParam+"="+this.value)
                    .then((r)=>{
                        if(r.data){
                            this.sessionID = r.data
                        }
                    });
            },
            sendVerification(e){
                e.preventDefault()
                this.verificationCodeButtonClicked = true
                var glue = this.validateSessionURL.includes("?")?"&":"?"
                axios.post(this.validateSessionURL+glue+this.sessionParam+"="+this.sessionID+"&"+this.codeParam+"="+this.validationCode)
                    .then((r)=>{
                        if(r.data && r.data == "ok"){
                            this.verificationCodeValidated = true
                        }
                    });
            },
            async evaluateValidationCondition(condition){
                if(condition.type && condition.type=='otc'){
                    if(!this.verificationCodeValidated){
                        return translations.plaseValidateYourPhoneWarning
                    }
                }
                return null;
            }
        }
    }
</script>